import axios from 'axios'

let cachedCss = null

async function getUrlAsBase64(url) {
  try {
    const response = await axios.get(url, { responseType: 'blob' })
    const blob = response.data
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onloadend = () => resolve(reader.result)
      reader.onerror = reject
      reader.readAsDataURL(blob)
    })
  } catch (error) {
    console.error(`Falha ao buscar ou converter a URL: ${url}`, error)
    return ''
  }
}

export async function getEmbeddedFontCss() {
  if (cachedCss) {
    return cachedCss
  }

  const fontUrls = {
    regular: 'https://fonts.gstatic.com/s/rubik/v30/iJWKBXyIfDnIV7nBrXw.woff2',
    light: 'https://fonts.gstatic.com/s/rubik/v30/iJWKBXyIfDnIV7nBrXw.woff2',
    bold: 'https://fonts.gstatic.com/s/rubik/v30/iJWKBXyIfDnIV7nBrXw.woff2',
  }

  const [base64Light, base64Regular, base64Bold] = await Promise.all([
    getUrlAsBase64(fontUrls.light),
    getUrlAsBase64(fontUrls.regular),
    getUrlAsBase64(fontUrls.bold),
  ])

  const finalCss = `
    @font-face {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 300;
      src: url(${base64Light}) format('woff2');
    }
    @font-face {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 400;
      src: url(${base64Regular}) format('woff2');
    }
    @font-face {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 700;
      src: url(${base64Bold}) format('woff2');
    }
    * {
      font-family: 'Rubik', sans-serif !important;
    }
  `

  cachedCss = finalCss

  return finalCss
}